import React , {useState, useEffect} from 'react';
import {Button, Form} from 'react-bootstrap';
import PropTypes from 'prop-types';
import ReactTable from 'react-table-v6';
import './deriveFormMedOrder.scss';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import ToggleButton from 'react-toggle-button';

const Drug_Access_List = "Drug Exclusion List";
const My_Pharmacies = "My Pharmacies";
const Rx_Order_Date = "Rx Order Date"

const columns = [
    {
        Header: 'Drug NDC',
        accessor: 'drugNdc',
        minWidth: 110,
    },
    {
        Header: 'Specialty Drug',
        accessor: 'specialtyDrug',
        minWidth: 300,
    },
    {
        Header: 'Generic Name',
        accessor: 'genericName',
        minWidth: 300,
    }
];

const columnPharmacy = [
    {
        Header: 'Pharamcy ID',
        accessor: 'pharmacyId',
        minWidth: 110,
    },
    {
        Header: 'Pharmacy Name',
        accessor: 'name',
        minWidth: 300,
    }
];


function DeriveFromMedOrder(props) {

   const [importOption , setImportOption] = useState(false);
   const [showCustomDate , setCustomDate] = useState(false);
   const [importOptionChecked , setImportOptionChecked] = useState(['All']);
   const [drugInclusionChecked , setDrugInclusionChecked] = useState(['All']);
   const [pharmacyData , setPharmacyData] = useState([]);
   const [nonListData , setNonListData] = useState([]);
   const [rxOrderDate , setRXOrderDate] = useState({totalCount: 0, yearCount: 0});


   const {toggleMedOrderModel, getPharmacyDetails, 
    getCustomerDrugNonAccessList, loadMedOrder,  
    getRXOrderDate } = props;

   useEffect(() => {

    (async () => {
        setPharmacyData(await getPharmacyDetails())
    })();

    (async () => {
        setRXOrderDate(await getRXOrderDate())
    })();

    (async () => {
        setNonListData(await getCustomerDrugNonAccessList());
    })();
   
   }, []);

   const toggleImportOption = () => {
        setImportOption(!importOption);
    };

    const handleImportOrderClick = (event) => {
        if(event.target.value === 'Custom'){
           setCustomDate(true);
        }else{
            setCustomDate(false);
        }

        setImportOptionChecked([event.target.value])
    };

    const handleDrugInclusionClick = (event) => {
        setDrugInclusionChecked([event.target.value])
    };
 
    const {totalCount , yearCount} = rxOrderDate;

    const loadMedOrderFilter = () => {
       loadMedOrder({importOptions: {
        includeNonSpecialityDrug: importOption === true ? 'Y' : 'N',
        drugInclusion: drugInclusionChecked,
        rxOrderDate: importOptionChecked
    }
});
    };

    return ( <>
                <div className="content-flex">
                    <div className="import-options">
                    <span className='derive-modal-title'>Import Options</span>
                        <div className="content-flex toggle-content">
                            <span className="mr-2 toggle-label">Include Non-Speciality Drug</span>
                            <ToggleButton
                                width={'50px'}
                                inactiveLabel={'NO'}
                                activeLabel={'YES'}
                                value={importOption}
                                colors={{
                                    activeThumb: {
                                        base: 'rgb(247, 247, 247)',
                                    },
                                    inactiveThumb: {
                                        base: 'rgb(247, 247, 247)',
                                    },
                                    active: {
                                        base: 'rgb(26, 108, 157, 1)',
                                        hover: 'rgb(26, 108, 157, 1)',
                                    },
                                    inactive: {
                                        base: 'rgb(65,66,68)',
                                        hover: 'rgb(95,96,98)',
                                    },
                                }}
                                onToggle={toggleImportOption}
                            />
                        </div> 
                        <div>
                            <span className='span-title'>Drug Inclusion Options</span><br/>
                            <input type="radio" id="drug-all" name="drug" value="All" checked = {drugInclusionChecked.includes('All')} onClick={(event) => handleDrugInclusionClick(event)}/>
                            <label className='radio-lable' htmlFor="drug-all">All Drugs</label><br/>
                            <input type="radio" id="drug-accessible" name="drug" value="Accessible" checked = {drugInclusionChecked.includes('Accessible')}  onClick={(event) => handleDrugInclusionClick(event)}/>
                            <label className='radio-lable' htmlFor="drug-accessible">Only Include Accessible Drugs</label><br/>  
                        </div>
                        <div className="import-order-date">
                                <span className='span-title'>{Rx_Order_Date}</span>

                                <div>
                                    <input type="radio" id="rx-all" name="rx" value="All" checked = {importOptionChecked.includes('All')} onClick={(event) => handleImportOrderClick(event)}/>
                                    <label className='radio-lable' htmlFor="rx-all">Not Filtered Date ({totalCount})</label><br/>
                                    <input type="radio" id="rx-one-year" name="rx" value="One-Year" checked = {importOptionChecked.includes('One-Year')} onClick={(event) => handleImportOrderClick(event)}/>
                                    <label className='radio-lable' htmlFor="rx-one-year">In The Past Year ({yearCount})</label><br/>  
                                    <input type="radio" id="rx-custom" name="rx" value="Custom" checked = {importOptionChecked.includes('Custom')} onClick={(event) => handleImportOrderClick(event)}/>
                                    <label className='radio-lable' htmlFor="rx-custom">Custom</label><br/>  
                                </div> 

                                { showCustomDate  && 
                                <div className='date-range'>
                                    <span className="mr-2">Select Date Range</span>
                                    <DateRangePicker >
                                    <Form.Control
                                            as="input"
                                            type="text"
                                            sm="5"
                                            size="sm"
                                            className="col-5 text-center"
                                        
                                            readOnly
                                            title="Time interval"
                                        />
                                    </DateRangePicker>
                                 </div>
                                 }
                        </div>
                    </div>

                    <div className='table-list table-list-pharmacy'>
                            <span className='derive-modal-title'>{My_Pharmacies}</span>
                            <ReactTable
                                filterable
                                defaultFilterMethod={(filter, row) =>
                                    row[filter.id] !== undefined
                                        ? String(row[filter.id]).toLowerCase().includes(filter.value.toLowerCase())
                                        : false
                                }
                                data={pharmacyData}
                                noDataText={'No Data Found'}
                                columns={columnPharmacy}
                                sortable={true}
                                showPagination={false}
                                showPageSizeOptions={false}
                                defaultPageSize={pharmacyData && pharmacyData.length ? pharmacyData.length : 4}
                                pageSize={pharmacyData && pharmacyData.length ? pharmacyData.length : 1}
                                className="-highlight actuals-tab w-100 table-ph-list"
                            />
                    </div>
                </div>
                <div className="body-content-med-order">
                       
                        <div className='table-list'>
                            <span className='derive-modal-title'>{Drug_Access_List}</span>
                            <ReactTable
                                filterable
                                defaultFilterMethod={(filter, row) =>
                                    row[filter.id] !== undefined
                                        ? String(row[filter.id]).toLowerCase().includes(filter.value.toLowerCase())
                                        : false
                                }
                                data={nonListData}
                                noDataText={'No Data Found'}
                                columns={columns}
                                sortable={true}
                                showPagination={false}
                                showPageSizeOptions={false}
                                defaultPageSize={nonListData && nonListData.length ? nonListData.length : 4}
                                pageSize={nonListData && nonListData.length ? nonListData.length : 1}
                                className="-highlight actuals-tab w-100 table-med-order"
                            />
                        </div>
                    </div>
                   
                <div className="body-footer text-right">
                    <Button type="button" className="submit-btn" size="sm" onClick={loadMedOrderFilter}>
                        Load
                    </Button>

                    <Button type="button" className="submit-btn" size="sm" onClick={toggleMedOrderModel}>
                        Cancel
                    </Button>
                </div>     
            </> );
  }
  DeriveFromMedOrder.propTypes = {
    toggleMedOrderModel: PropTypes.func,
    getPharmacyDetails: PropTypes.func,
    getCustomerDrugNonAccessList: PropTypes.func,
    loadMedOrder: PropTypes.func,
    getRXOrderDate: PropTypes.func
  };

  export default DeriveFromMedOrder;

